export default class CountdownComponent extends HTMLElement {
	constructor() {
		super();
		this.countdownDate = new Date(this.dataset.countdown);
    this.init();
	}

  init() {
    const countDownDate = this.countdownDate.getTime();

		// Update the count down every 1 second
		this.interval = setInterval(() => {
			// Get today's date and time
			const now = new Date().getTime();

			// Find the distance between now and the count down date
			const distance = countDownDate - now;

			// Time calculations for days, hours, minutes and seconds
			const days = Math.floor(distance / (1000 * 60 * 60 * 24));
			const hours = Math.floor(
				(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
			);
			const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((distance % (1000 * 60)) / 1000);

			// Display the result in the element with id="demo"
			this.innerHTML = `
				<span class="inline-flex gap-1 items-center leading-x90 px-1.5 -my-0.5">
					${this.component(days, "Days")}
					${this.component(hours, "Hrs")}
					${this.component(minutes, "Mins")}
					${this.component(seconds, "Secs", true)}
				</span>
			`;

			// If the count down is finished, write some text
			if (distance < 0) {
				clearInterval(this.interval);
				this.innerHTML = "now"; // TODO: What to do with empty
			}
		}, 1000);
  }

	component(time = 0, title = 'Secs', last = false) {
		const el = "clock-time";
		return `
			<span class="${el} block text-center">
				<span class="${el}__number text-x120 flex items-center justify-center gap-1 leading-6">
					${String(time).padStart(2, "0")}
					${!last ? '<span class="text-base leading-none">:</span>' : ""}
				</span>
				<span class="${el}__title block text-x60 -mt-1">${title}</span>
			</span>
		`;
	}
}
